import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateLdap } from "../../../actions/actionLdap";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import LdapForm from "../LdapForm/LdapForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import MappingTable from "../../../components/MappingTable/";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Ldap",path:"/ldap",isActive: false},
    {name: "UpdateLdap",path:"/updateldap",isActive: true},
];

class UpdateLdap extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update LDAP Configuration</strong>
                                </CardHeader>
                                <LdapForm
                                    updateLdap={this.props.updateLdap}
                                    ldapId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                            <Card className = "user-form-container">
                                <MappingTable sso_id={this.props.match.params.id} sso_type="LDAP" />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateLdap.propTypes = {
    updateLdap: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    ldap_configs: state.ldap_configs.ldap_configs || []
}), 
dispatch => ({
    updateLdap: () => dispatch(updateLdap())
}))(UpdateLdap);